window.Vue = require('vue');
import VModal from 'vue-js-modal';
window.Vue.use(VModal);
Vue.config.devtools = Vue.config.performance = process.env.NODE_ENV !== 'production';

/** Отслеживаем клик вне рабочей области компонента **/
import ClickOutside from 'vue-click-outside';
/** Библиотека bootstrap компонентов для Vue **/
import BootstrapVue from 'bootstrap-vue';
/** Хранилище состояни приложения **/
import store from 'jsAssets/store/index';
/** Библиотека для работы с адаптивом **/
import VueMq from 'vue-mq';

/** Настраиваем разрешения экрана **/
import {MQ_BREAKPOINTS} from 'jsAssets/constants/media';
Vue.use(VueMq, {
    breakpoints: MQ_BREAKPOINTS
});

Vue.use(BootstrapVue);

Vue.directive('click-outside', ClickOutside);

/*
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCP0yplUfsYIfC20lR4OQeRXbTVf2bpg0Y',
        libraries: 'places', // This is required if you use the Autocomplete plugin
        region: 'UK',
        language: 'uk',
        // OR: libraries: 'places,drawing'
        // OR: libraries: 'places,drawing,visualization'
        // (as you require)

        //// If you want to set the version, you can do so:
        // v: '3.26',
    },

    //// If you intend to programmatically custom event listener code
    //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
    //// you might need to turn this on.
    // autobindAllEvents: false,

    //// If you want to manually install components, e.g.
    //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
    //// Vue.component('GmapMarker', GmapMarker)
    //// then disable the following:
    // installComponents: true,
});
*/

Vue.component('loading-indicator', require('vueComponents/animation/LoadingIndicator').default);
//Vue.component('auth-page', require('vueContainers/Auth'));
//Vue.component('checkout-page', require('vueContainers/Checkout'));
//Vue.component('header-select-city', require('vueComponents/header/SelectCity'));
//Vue.component('cart-small', require('vueComponents/header/Cart'));

Vue.component('basket-page', require('vueContainers/Basket').default);
Vue.component('create-project', require('vueComponents/project/CreateProject').default);
Vue.component('mini-top-basket', require('vueComponents/product/basket/MiniBasket').default);
Vue.component('mini-top-favorite', require('vueComponents/product/favorite/MiniFavorite').default);
Vue.component('mini-top-compare', require('vueComponents/product/compare/MiniCompare').default);
Vue.component('catalog-item-basket-btn', require('vueComponents/product/basket/CatalogItemBasket').default);
Vue.component('favorite-catalog-item', require('vueComponents/product/favorite/FavoriteCatalogItem').default);
Vue.component('favorite-list-delete-item', require('vueComponents/product/favorite/DeleteFavoriteItem').default);
Vue.component('compare-page-delete-item', require('vueComponents/product/compare/ComparePageDeleteItem').default);
Vue.component('compare-catalog-item', require('vueComponents/product/compare/CompareCatalogItem').default);
Vue.component('product-detail-input', require('vueComponents/product/ProductDetailInput').default);
Vue.component('product-detail-order-btn', require('vueComponents/product/ProductDetailOrderBtn').default);
Vue.component('course-order-form', require('vueComponents/course/CourseOrderForm').default);
Vue.component('course-detail-form', require('vueComponents/course/CourseDetailForm').default);
Vue.component('choose-course-btn', require('vueComponents/course/ChooseCourseBtn').default);
Vue.component('test-vue', require('vueComponents/Test').default);
Vue.component('project', require('vueContainers/Project').default);
Vue.component('detail-project-name', require('vueComponents/project/DetailProjectName').default);
Vue.component('detail-project-info', require('vueComponents/project/DetailProjectInfo').default);
Vue.component('project-detail', require('vueContainers/ProjectDetail').default);
Vue.component('add-to-project', require('vueComponents/project/AddToProject').default);
Vue.component('project-item-quantity', require('vueComponents/project/ProjectItemQuantity').default);
Vue.component('project-logo', require('vueComponents/project/ProjectLogo').default);
Vue.component('view-settings', require('vueComponents/ViewSettings').default);
Vue.component('def-modal-alert', require('vueComponents/modals/def-modal-alert').default);
Vue.component('orders-history', require('vueContainers/OrdersHistory').default);

require('./vue_mixins');

const app = new Vue({
    el: '#app',
    store,
    mounted() {
        console.log('z0');
        $(document).trigger('vue-loaded');
        console.log('z10');
        this.$store.dispatch('app/getInitData');
    }
});

const projects = new Vue({
    el: '#projects',
    store,
    mounted() {
        $(document).trigger('vue-loaded');
        console.log('project test-10');
        this.$store.dispatch('app/getInitData');
    }
});

import FaqMenu from "./components/faq/FaqMenu";

const createPropsFromAttributes = (htmlElement) => {
    try {
        if (htmlElement && htmlElement.dataset) {
            const dataset = htmlElement.dataset;
            let params = {  }
            for (let key in dataset) {
                if (key === 'vue') continue;
                params[ key ] = JSON.parse(dataset[ key ]);
            }

            return params;
        }
    } catch (err) {
        console.error(err);
    }
}

if (document.querySelector('.faq-menu-vue')) {
    const faqMenu = new Vue({
        el: '.faq-menu-vue',
        store,
        render: (h) => h(FaqMenu, { props: createPropsFromAttributes(document.querySelector('.faq-menu-vue')) }),
        mounted() {
            $(document).trigger('vue-loaded');
            console.log('project test-10');
            this.$store.dispatch('app/getInitData');
        }
    });
}

import QuestionsForm from "./components/faq/QuestionsForm/QuestionsForm";

if (document.querySelector('.questions-form-vue')) {
    const faqMenu = new Vue({
        el: '.questions-form-vue',
        store,
        render: (h) => h(QuestionsForm, { props: createPropsFromAttributes(document.querySelector('.questions-form-vue')) }),
        mounted() {
            $(document).trigger('vue-loaded');
            console.log('project test-10');
            this.$store.dispatch('app/getInitData');
        }
    });
}